import {AppConfigDataSourceContentType} from "@/model/AppConfigDatasource";

export enum AppConfigPageType {
    SINGLE = 1,
    MULTI = 2
}

export const AppConfigPageTypeValues = [AppConfigPageType.SINGLE, AppConfigPageType.MULTI]
export const AppConfigPageTypeName = (value: AppConfigPageType) => {
    switch (value) {
        case AppConfigPageType.MULTI:
            return "组合页面"
        case AppConfigPageType.SINGLE:
            return "单页面"
    }
}

export enum AppConfigPageScope {
    MOBILE = 1,
    PC = 2
}

export const AppConfigPageScopeValues = [AppConfigPageScope.MOBILE, AppConfigPageScope.PC]
export const AppConfigPageScopeName = (value: AppConfigPageScope) => {
    switch (value) {
        case AppConfigPageScope.MOBILE:
            return "移动端"
        case AppConfigPageScope.PC:
            return "电脑端"
    }
}

export interface AppConfigPage {

    id: string | null
    /**
     * 页面名
     */
    name: string | null

    /**
     * 页面类型
     */
    type: AppConfigPageType | null

    /**
     * 子页面
     */
    pages: AppConfigSubPage[] | null
}

export interface AppConfigPageDetail extends AppConfigPage {

    /**
     * 组件
     */
    components: AppConfigComponent[] | null
}


export interface AppConfigSubPage {
    // 关联的pageId
    id?: string
    name?: string
}

export interface AppConfigComponent {

    /**
     * 给前端做唯一id用，每次请求都会变化
     */
    uuid?: string
    /**
     * 模块类型
     */
    type?: AppConfigComponentType

    /**
     * 列表
     */
    list?: AppConfigComponentList

    /**
     * 在type=NAVIGATION_GROUP情况下，该值有效
     */
    navGroup?: AppConfigComponentNavGroup

    /**
     * 在type=TAB_GROUP情况下，该值有效
     */
    listGroup?: AppConfigComponentListGroup

    // 资讯配置
    news?: AppConfigComponentNews

    /**
     * 广告
     */
    ad?: AppConfigComponentAd

    /**
     * 间距
     */
    gap?: number
}

export enum AppConfigComponentType {
    /**
     * 广告组件
     */
    AD = 1,

    /**
     * 导航组组件
     */
    NAVIGATION_GROUP = 2,

    /**
     * 列表组件
     */
    LIST = 3,

    /**
     * 列表分组组件
     */
    LIST_GROUP = 4,

    /**
     * 资讯
     */
    NEWS = 5
}

export const AppConfigComponentTypeName = (type: AppConfigComponentType) => {
    switch (type) {
        case AppConfigComponentType.LIST:
            return "列表"
        case AppConfigComponentType.AD:
            return "广告"
        case AppConfigComponentType.NAVIGATION_GROUP:
            return "导航"
        case AppConfigComponentType.LIST_GROUP:
            return "列表分组"
    }
}

export const AppConfigComponentTypeValues = [AppConfigComponentType.AD,
    AppConfigComponentType.NAVIGATION_GROUP,
    AppConfigComponentType.LIST,
    AppConfigComponentType.LIST_GROUP]

export enum AppConfigComponentListStyle {
    VERTICAL = 1,
    HORIZONTAL = 2
}

export const AppConfigComponentListStyleValues = [AppConfigComponentListStyle.VERTICAL, AppConfigComponentListStyle.HORIZONTAL]
export const AppConfigComponentListStyleName = (style: AppConfigComponentListStyle) => {
    switch (style) {
        case AppConfigComponentListStyle.VERTICAL:
            return "卡片"
        case AppConfigComponentListStyle.HORIZONTAL:
            return "紧凑"
    }

    return ""
}

// 列表组件配置
export interface AppConfigComponentList {
    /**
     * 广告id
     */
    adItems?: AppConfigComponentAdItem[]

    /**
     * 限制数量，0表示无限加载
     */
    limitNumber?: Number

    /**
     * 在type=List情况下，该值有效
     */
    style?: AppConfigComponentListStyle

    /**
     * 数据源id
     */
    datasourceId?: string

    /**
     * 数据源id
     */
    datasource?: {
        id?: string,
        name?: string
        contentType?: AppConfigDataSourceContentType
    }

    /**
     * 是否显示头部
     */
    showHeader?: boolean

    /**
     * 是否显示更多
     */
    showMore?: boolean

    /**
     * 列表展示名字
     */
    name?: string
}

export enum AppConfigComponentAdType {
    /**
     * 平面广告
     */
    PLAIN = 1,

    /**
     * 胶囊广告
     */
    CAPSULE = 2
}

export const AppConfigComponentAdTypeValues = [AppConfigComponentAdType.PLAIN, AppConfigComponentAdType.CAPSULE]
export const AppConfigComponentAdTypeName = (type: AppConfigComponentAdType) => {
    switch (type) {
        case AppConfigComponentAdType.PLAIN:
            return "轮播广告"
        case AppConfigComponentAdType.CAPSULE:
            return "胶囊广告"
    }
    return ""
}

// 广告组件配置
export interface AppConfigComponentAd {
    type?: AppConfigComponentAdType
    items?: AppConfigComponentAdItem[]
    subItems?: AppConfigComponentAdItem[]
    showMenuNavigation?: boolean
}

export interface AppConfigComponentListGroupItem {
    name?: string,
    datasourceId?: string,
    uuid: string,
    style?: AppConfigComponentListStyle,
    datasource?: {
        id: string,
        name: string,
        contentType: AppConfigDataSourceContentType
    }
}

// 资讯组件配置
export interface AppConfigComponentNews {
    name?: string
}

// 标签切换组件配置
export interface AppConfigComponentListGroup {
    name?: string
    items?: AppConfigComponentListGroupItem[]
}

export enum AppConfigComponentNavGroupItemJumpType {
    /**
     * 页面
     */
    PAGE = 1,

    /**
     * 网页
     */
    URL = 2
}

export const AppConfigComponentNavGroupItemJumpTypeValues = [AppConfigComponentNavGroupItemJumpType.PAGE, AppConfigComponentNavGroupItemJumpType.URL]
export const AppConfigComponentNavGroupItemJumpTypeName = (type: AppConfigComponentNavGroupItemJumpType) => {
    switch (type) {
        case AppConfigComponentNavGroupItemJumpType.PAGE:
            return "页面"
        case AppConfigComponentNavGroupItemJumpType.URL:
            return "链接"
    }
    return ""
}

export interface AppConfigComponentNavGroupItem {
    jumpType: AppConfigComponentNavGroupItemJumpType | null,
    link: string | null,
    uuid: string | null,
    name: string | null,
    icon: string | null,
    page: AppConfigComponentRelatePage | null
    pageId: string | null
}

// 导航组件配置
export interface AppConfigComponentNavGroup {
    items: AppConfigComponentNavGroupItem[] | null
}

export interface AppConfigComponentRelatePage {
    id: string | null

    // 关联的page名字
    name: string | null

    scope: AppConfigPageScope | null
}

export interface AppConfigComponentAdItem extends Record<any, any> {

    uuid: string | null,

    /**
     * 图片url
     */
    imageUrl: string | null

    /**
     * 跳转链接
     */
    link: string | null

    /**
     * 有效期开始时间
     */
    startTime: number | null

    /**
     * 有效期结束时间
     */
    endTime: number | null
}

export enum AppConfigDraftStatus {
    // 编辑中
    EDITING = 1,
    // 发布中
    PUBLISHED = 2
}

export interface AppConfigDraft {

    id: string | null

    pageId: string | null

    /**
     * 状态
     */
    status: AppConfigDraftStatus | null

    /**
     * 关联页面
     */
    page: AppConfigComponentRelatePage

    /**
     * 创建时间
     */
    createdAt: number | null

    /**
     * 发布时间
     */
    publishTime: number | null

    /**
     * 管理员
     */
    manager: {
        id: string | null,
        name: string | null
    } | null
}

export interface AppConfigDraftDetail extends AppConfigDraft{
    components: AppConfigComponent[] | null
}

